<template>
  <div style="background-color: #f8f8f8; border-top: 2px solid #fea923">
    <div class="main-width">
      <div class="top-wrap">
        <div class="category-box" @mouseleave="popupClose">
          <div class="category-list">
            <router-link
              v-for="(item, index) in listCategoriesArr"
              :key="index"
              tag="a"
              :to="{
                name: 'Category',
                query: {
                  levelOne: item.id,
                  levelOneText: item.name,
                  levelTwo: '',
                  levelThree: '',
                  keyWord: '',
                  selectType: '',
                  brandId: '',
                },
              }"
            >
              <div
                @mouseenter="popupInit(index)"
                class="category-li"
                :class="item.active == true ? 'active' : ''"
              >
                {{ item.name }}
                <i class="el-icon-arrow-right category-right-icon"></i>
              </div>
            </router-link>
          </div>
          <div
            v-if="showCategoryDetail == true"
            class="category-detail main-popup"
          >
            <div>
              <div
                v-for="(item, index) in listCategoriesArr2"
                :key="index"
                class="main-popup-item"
              >
                <div class="main-popup-category">
                  <router-link
                    tag="a"
                    :to="{
                      name: 'Category',
                      query: {
                        levelOne: item.parentId,
                        levelOneText: item.name2,
                        levelTwo: item.id,
                        levelTwoText: item.name,
                        levelThree: '',
                        keyWord: '',
                        selectType: '',
                        brandId: '',
                      },
                    }"
                    >{{ item.name }}</router-link
                  >
                </div>
                <ul class="main-popup-category-child">
                  <li
                    v-for="(itm, idx) in item.categories"
                    :key="idx"
                    class="category-detail-li"
                  >
                    <router-link
                      class="cdl"
                      tag="a"
                      :to="{
                        name: 'Category',
                        query: {
                          levelOne: item.parentId,
                          levelOneText: item.name2,
                          levelTwo: itm.parentId,
                          levelTwoText: item.name,
                          levelThree: itm.id,
                          levelThreeText: itm.name,
                          keyWord: '',
                          selectType: '',
                          brandId: '',
                        },
                      }"
                      >{{ itm.name }}</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-box">
          <el-carousel height="400px">
            <el-carousel-item
              v-for="(item, index) in listCirculationPicturesArr"
              :key="index"
            >
              <a :href="item.activity">
                <div
                  class="carousel-img"
                  :style="{ backgroundImage: 'url(' + item.image + ')' }"
                ></div>
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="account-box">
          <div class="main-photo">
            <img :src="imgAddress + logoPath" @error="error(4)" />
          </div>
          <div class="main-name">
            HI，<span>{{ accountInfo.account }}</span>
          </div>
          <div style="font-size: 14px; text-align: center; color: #333">
            {{ headerName }}
          </div>
          <div
            style="
              font-size: 12px;
              color: #999;
              text-align: center;
              margin-bottom: 20px;
              margin-top: 10px;
              cursor: pointer;
            "
          >
            <span @click="layout">退出登录</span>
          </div>
          <div class="account-detail-list">
            <div class="account-detail-list-title">
              <img
                src="../assets/img/home-enterBrandCount.png"
                alt=""
                style="width: 14px; position: relative; width: 14px; top: 2px"
              />
              已入驻品牌
            </div>
            <div class="account-detail-list-num">
              {{ accountInfo.enterBrandCount }}
            </div>
          </div>
          <div class="account-detail-list">
            <div class="account-detail-list-title">
              <img
                src="../assets/img/home-enterSKUCount.png"
                alt=""
                style="width: 14px; position: relative; width: 14px; top: 2px"
              />
              已入驻SKU
            </div>
            <div class="account-detail-list-num">
              {{ accountInfo.enterSKUCount }}
            </div>
          </div>
          <div class="account-detail-list">
            <div class="account-detail-list-title">
              <img
                src="../assets/img/home-enterPlatformCount.png"
                alt=""
                style="width: 14px; position: relative; width: 14px; top: 2px"
              />
              选货第三方
            </div>
            <div class="account-detail-list-num">
              {{ accountInfo.enterPlatformCount }}
            </div>
          </div>
        </div>
      </div>

      <div class="recommend-wrap">
        <section
          v-for="(ele, iii) in smallSerialListArr"
          :key="iii"
          class="recommend-box"
        >
          <div>
            <img
              v-if="ele.jumpStyle == '1'"
              style="width: 100%"
              :src="ele.coverImgpath"
              alt=""
            />
            <a v-if="ele.jumpStyle == '3'" :href="ele.jumpTo" target="_blank">
              <img
                style="width: 100%; cursor: pointer"
                :src="ele.coverImgpath"
                alt=""
              />
            </a>
            <router-link
              v-if="ele.jumpStyle == '4'"
              tag="a"
              target="_blank"
              :to="{ name: 'Recommend', query: { serialId: ele.id } }"
            >
              <img
                style="width: 100%; cursor: pointer"
                :src="ele.coverImgpath"
                alt=""
              />
            </router-link>
          </div>
          <div v-if="ele.goodsObj">
            <div class="category-goods-wrap">
              <ul class="category-goods-list">
                <li
                  style="background-color: #fff; height: 380px"
                  class="category-goods-item"
                  v-for="(item, index) in ele.goodsObj.goodsList"
                  v-if="index < ele.showLength"
                  :key="index"
                >
                  <div class="category-goods-image">
                    <router-link
                      tag="a"
                      target="_blank"
                      :to="{
                        name: 'Detail',
                        query: { goodsId: item.responseAppGoodsVo.goodsId },
                      }"
                    >
                      <!-- <img
                        :src="imgAddress + item.responseAppGoodsVo.goodsImage"
                        @error="error(1)"
                      /> -->
                      <div
                        class="recommend-image"
                        :style="{
                          backgroundImage:
                            'url(' +
                            imgAddress +
                            item.responseAppGoodsVo.goodsImage +
                            ')',
                        }"
                      ></div>
                      <div
                        class="category-cover-image"
                        :class="{ a: item.responseAppGoodsVo.isBill == 1 }"
                      ></div>
                      <div class="category-hover-product">
                        <table border="0" cellspacing="0" cellpadding="0">
                          <thead>
                            <tr>
                              <th>SKU</th>
                              <th>
                                <span v-if="item.responseAppGoodsVo.isBill == 0">
                                  不带票结算价
                                  <span
                                    v-if="item.responseAppGoodsVo.supplyChannel == 1"
                                    >(+运费)</span
                                  >
                                </span>
                                <span v-else>
                                  带票结算价
                                  <span
                                    v-if="item.responseAppGoodsVo.supplyChannel == 1"
                                    >(+运费)</span
                                  >
                                </span>
                              </th>
                              <th>库存</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(itm, idx) in item.responseAppGoodsVo.products"
                              v-if="idx < 7"
                              :key="idx"
                            >
                              <td class="category-table-SKU">
                                <div>{{ itm.specName }}</div>
                              </td>
                              <td>
                                <span v-if="item.responseAppGoodsVo.isBill == 0">
                                  {{ itm.settlementPrice / 100 }}
                                  <span
                                    class="freight-price"
                                    v-if="item.responseAppGoodsVo.supplyChannel == 1"
                                    >(+{{ itm.freight / 100 }})</span
                                  >
                                </span>
                                <span v-else>
                                  {{ itm.settlementPrice / 100 }}
                                  <span
                                    class="freight-price"
                                    v-if="item.responseAppGoodsVo.supplyChannel == 1"
                                    >(+{{ itm.freight / 100 }})</span
                                  >
                                </span>
                              </td>
                              <td>
                                <span v-if="item.responseAppGoodsVo.isBill == 0">{{
                                  itm.inventoryNum
                                }}</span>
                                <span v-else>{{ itm.inventoryNum }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </router-link>
                  </div>

                  <div class="category-goods-info">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      v-bind:content="item.responseAppGoodsVo.goodsName"
                      placement="top"
                    >
                      <div class="category-goods-title2">
                        {{ item.responseAppGoodsVo.goodsName }}
                      </div>
                    </el-tooltip>
                    <div class="category-goods-type">
                      <div
                        v-if="
                          item.responseAppGoodsVo.supplyChannel == 2 ||
                          item.responseAppGoodsVo.supplyChannel == 3
                        "
                      >
                        社群集采
                      </div>
                      <div v-if="item.responseAppGoodsVo.supplyChannel == 1">
                        一件代发
                      </div>
                      <div
                        style="
                          background-color: rgb(231, 249, 235);
                          color: rgb(88, 191, 106);
                        "
                        v-if="item.responseAppGoodsVo.isSelf == 1"
                      >
                        自产自销
                      </div>
                    </div>
                    <div class="category-goods-price2">
                      <div>
                        结算价
                        <span>
                          ¥
                          <span style="font-size: 18px">{{
                            item.responseAppGoodsVo.originSettlementPrice / 100
                          }}</span>
                        </span>
                      </div>
                      <div>
                        毛利率 ¥
                        {{
                          (
                            ((item.responseAppGoodsVo.salePrice -
                              item.responseAppGoodsVo.settlementPrice) /
                              item.responseAppGoodsVo.salePrice) *
                            100
                          ).toFixed(2) + "%"
                        }}
                      </div>
                    </div>
                    <div class="category-goods-price3">
                      <div>
                        建议零售价 ¥ {{ item.responseAppGoodsVo.salePrice / 100 }}
                      </div>
                      <div>
                        毛利 ¥
                        <span style="color: #ff6015">{{
                          (
                            item.responseAppGoodsVo.salePrice -
                            item.responseAppGoodsVo.settlementPrice
                          ).toFixed(2) / 100
                        }}</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="show-more">
                <span
                  v-if="ele.goodsObj.count > ele.showLength"
                  @click="showLength(iii)"
                  >更多<i class="el-icon-arrow-down"></i
                ></span>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="footer-wrap">
        <img
          v-for="(item, index) in footerImg"
          :key="index"
          :src="item.path"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import store from "../store/index.js";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import {
  layout,
  enterInfo,
  imgAddress,
  listCategories,
  listCirculationPictures,
  smallSerialList,
  smallSerialGoods,
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import router from "../router/index.js";

export default {
  data() {
    return {
      headerName: this.$store.state.headerName,
      accountInfo: {
        account: store.state.account,
        enterBrandCount: "",
        enterPlatformCount: "",
        enterSKUCount: "",
      },

      imgAddress: imgAddress,

      logoPath: store.state.logoPath,

      userId: store.state.userId,
      appId: store.state.appId,
      bodyId: store.state.bodyId,

      footerImg: [
        {
          path: require("../assets/img/jinkouhuoyuan@2x.png"),
        },
        {
          path: require("../assets/img/pinpaizhixiao@2x.png"),
        },
        {
          path: require("../assets/img/quanqiubida@2x.png"),
        },
        {
          path: require("../assets/img/shouhouwuyou@2x.png"),
        },
        {
          path: require("../assets/img/yijiandaifa@2x.png"),
        },
      ],

      colorMain: store.state.colorMain,
      listCategoriesArr: [], //分类
      listCategoriesArr2: [], //悬停时右边的二三级分类
      showCategoryDetail: false,
      listCirculationPicturesArr: [], //轮播图
      pageNum: 1,
      pageSize: 10,
      smallSerialListArr: [],
      getSmallSerialListBool: true,
      smallSerialListArrNone: false,
    };
  },
  components: {},
  computed: {},
  mounted() {
    this.pageNum = 1;
    this.smallSerialListArrNone = false;
    this.enterInfoInit();
    this.getListCategories();
    this.getListCirculationPictures();
    this.getSmallSerialList();
    window.addEventListener("scroll", this.handleScroll); // 滚动加载更多
  },
  methods: {
    handleScroll() {
      let _this = this;
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let innerHeight = window.innerHeight;
      let clientHeight = document.body.clientHeight;

      if (parseInt(scrollTop + innerHeight) >= clientHeight) {
        // 触发加载数据
        this.getSmallSerialList();
      }
    },
    getSmallSerialList() {
      if (
        this.getSmallSerialListBool == true &&
        this.smallSerialListArrNone == false
      ) {
        this.getSmallSerialListBool = false;

        let data = {
          userId: this.userId,
          appId: this.appId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        };
        let url = smallSerialList;
        fetch(url, data).then((res) => {
          if (res.code == 10000) {
            let list = res.data.result;
            list.forEach((item, index) => {
              item.showLength = 15;
              if (window.location.host.indexOf("localhost") == -1) {
                if (item.jumpStyle == 3) {
                  item.jumpTo = item.jumpTo.replace(
                    "small.jioao.cn",
                    window.location.host
                  );
                }
              }
              this.smallSerialListArr.push(item);
            });

            list.forEach((item, index) => {
              this.getSmallSerialGoods(
                (this.pageNum - 1) * this.pageSize + index
              );
            });
            if (list.length < this.pageSize) {
              this.smallSerialListArrNone = true;
            }
            this.pageNum++;
            this.getSmallSerialListBool = true;
          }
        });
      }
    },
    getSmallSerialGoods: function (index) {
      let data = {
        userId: this.userId,
        appId: this.appId,
        serialId: this.smallSerialListArr[index].id,
      };
      let url = smallSerialGoods;
      fetch(url, data).then((res) => {
        if (res.code == 10000) {
          this.smallSerialListArr[index].goodsObj = res.data;
          this.smallSerialListArr = JSON.parse(
            JSON.stringify(this.smallSerialListArr)
          );
        }
      });
    },
    showLength(iii) {
      this.smallSerialListArr[iii].showLength = this.smallSerialListArr[
        iii
      ].goodsObj.count;
    },
    enterInfoInit() {
      var data = {
        userId: this.userId,
      };
      var url = enterInfo;
      fetch(url, data).then((res) => {
        this.accountInfo.enterBrandCount = res.data.enterBrandCount;
        this.accountInfo.enterPlatformCount = res.data.enterPlatformCount;
        this.accountInfo.enterSKUCount = res.data.enterSKUCount;
      });
    },
    // 分类列表
    getListCategories() {
      let _this = this;
      let data = {
        userId: this.userId,
        appId: this.appId,
        bodyId: this.bodyId,
      };
      let url = listCategories;
      fetch(url, data).then((res) => {
        if (res.code == 10000) {
          _this.listCategoriesArr = res.data;
          _this.listCategoriesArr.forEach((item, index) => {
            item.active = false;
          });
        }
      });
    },
    popupInit(index) {
      let _this = this;
      // 要展示的二级三级分类
      let listCategoriesArr2 = [];
      let listCategoriesArr = _this.listCategoriesArr;
      _this.listCategoriesArr.forEach((item, index) => {
        item.active = false;
      });
      listCategoriesArr[index].active = true;
      listCategoriesArr[index].categories.forEach((ele, idx) => {
        ele.name2 = listCategoriesArr[index].name;
        listCategoriesArr2.push(ele);
      });
      _this.listCategoriesArr2 = listCategoriesArr2;

      this.showCategoryDetail = true;
    },
    popupClose() {
      let _this = this;
      _this.listCategoriesArr.forEach((item, index) => {
        item.active = false;
      });
      _this.showCategoryDetail = false;
    },
    getListCirculationPictures() {
      let _this = this;
      let data = {
        userId: this.userId,
        appId: this.appId,
        bodyId: this.bodyId,
      };
      let url = listCirculationPictures;
      fetch(url, data).then((res) => {
        if (res.code == 10000) {
          _this.listCirculationPicturesArr = res.data;
          if (window.location.host.indexOf("localhost") == -1) {
            _this.listCirculationPicturesArr.forEach((item, index) => {
              if (item.activity) {
                item.activity = item.activity.replace(
                  "small.jioao.cn",
                  window.location.host
                );
              }
            });
          }
        }
      });
    },

    layout() {
      var data = {
        userId: this.userId,
        appId: this.$store.state.appId,
      };
      var url = layout;
      fetch(url, data).then((res) => {
        if (res.code == 10000) {
          router.push("/");
        } else {
          var str = "退出登录失败";
          toast(str, 2, false);
        }
      });
    },
    error(num) {
      imageError(num, event);
    },
  },
};
</script>
<style scoped>
@import "../assets/css/swiper.min.css";
.top-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;

  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  margin-bottom: 40px;
}
.category-box {
  position: relative;
}
.category-list {
  min-height: 400px;
  width: 200px;
  background-color: #fff;
  font-size: 14px;
  color: #333;
}
.category-li {
  height: 40px;
  line-height: 40px;
  padding: 0 15px 0 20px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
}
.category-li.active {
  color: #fff;
  background-color: #fea923;
}
.category-right-icon {
  position: absolute;
  right: 15px;
  top: 12px;
}
.carousel-box {
  width: 860px;
}
.account-box {
  width: 200px;
  height: 400px;
  background-color: #fff;
}
.category-detail {
  width: 880px;
  min-height: 400px;
  left: 200px;
  box-shadow: none;
  border: 2px solid #fea923;
  border-top: none;
  box-sizing: border-box;
}
.category-detail-li:hover .cdl {
  color: #fea923;
}
.account-detail-list {
  background-color: #fafafa;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;

  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 6px;
  box-sizing: border-box;
  width: 90%;
  margin: 0 auto;
  margin-bottom: 10px;
}
.account-detail-list-title {
  width: 60%;
  color: #333;
  font-size: 14px;
}
.account-detail-list-num {
  width: 40%;
  text-align: center;
  color: #cea163;
  font-size: 16px;
}
.carousel-img {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.footer-wrap {
  text-align: center;
  padding-bottom: 20px;
}
.footer-wrap img {
  width: 135px;
  margin: 0 40px;
}
.recommend-wrap .category-hover-product {
  display: none;
}
.recommend-wrap .category-goods-image:hover .category-hover-product {
  display: block;
}
.recommend-box {
  margin-bottom: 20px;
}
.show-more {
  text-align: center;
  cursor: pointer;
}
</style>

<style scoped>
.category-cover-image.a {
  background: url(../assets/img/hanshui.png) no-repeat top right/60px 60px;
}
.category-cover-image {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: url(../assets/img/buhanshui.png) no-repeat top right/60px 60px;
}
.category-filter-condition-item2 {
  display: inline-block;
  height: 33px;
  width: 90px;
  font-size: 12px;
  line-height: 33px;
  color: #494949;
  background-image: url(../assets/img/jiage_weixuan.png);
  background-repeat: no-repeat;
  background-size: 8px;
  background-position: 68px center;
  border-right: 1px solid #f1f1f1;
  text-indent: 30px;
  cursor: pointer;
}
.category-filter-condition-item2.s1 {
  background-image: url(../assets/img/jiage_sheng.png);
}
.category-filter-condition-item2.s2 {
  background-image: url(../assets/img/jiage_jiang.png);
}

.category-goods-price2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.category-goods-price2 > div:nth-child(1) {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}

.category-goods-price2 > div:nth-child(1) > span {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(254, 169, 35, 1);
  line-height: 17px;
}
.category-goods-price2 > div:nth-child(2) {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}
.category-goods-price3 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  margin-top: 5px;
}
.category-goods-type {
  display: flex;
  flex-direction: row;
  margin: 6px 0;
}
.category-goods-type > div {
  width: 60px;
  height: 22px;
  background: rgba(255, 248, 249, 1);
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: 10px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(255, 77, 94, 1);
  line-height: 17px;
}
.category-goods-title2 {
  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  height: 38px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.recommend-image {
  width: 240px;
  height: 240px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>




// WEBPACK FOOTER //
// Home.vue?e6558540